export { default } from "./generateEventPair";
